export const emitRealtimeEvent = (eventName, payload = {}) => {
  const recordDivergence = (legacy, serverless) => {
    if (!window) {
      return;
    }
    if (!window.__phase1cDivergenceDashboard) {
      window.__phase1cDivergenceDashboard = {};
    }
    const prev = window.__phase1cDivergenceDashboard[eventName] || {
      total: 0,
      bothOk: 0,
      legacyOnly: 0,
      serverlessOnly: 0,
      neither: 0,
      lastUpdatedAt: null,
    };
    const next = {
      ...prev,
      total: prev.total + 1,
      bothOk: prev.bothOk + (legacy && serverless ? 1 : 0),
      legacyOnly: prev.legacyOnly + (legacy && !serverless ? 1 : 0),
      serverlessOnly: prev.serverlessOnly + (!legacy && serverless ? 1 : 0),
      neither: prev.neither + (!legacy && !serverless ? 1 : 0),
      lastUpdatedAt: new Date().toISOString(),
    };
    window.__phase1cDivergenceDashboard[eventName] = next;
    console.log("[Phase1C][Portal][divergence]", {
      eventName,
      metrics: next,
    });
  };

  const dualEmitLegacyEnabled =
    process &&
    process.env &&
    process.env.REACT_APP_DUAL_EMIT_LEGACY === "true";
  const sendViaServerless = window && window.emitServerlessWsEvent;
  const canUseServerless = typeof sendViaServerless === "function";
  const canUseLegacy = Boolean(window && window.socket && window.socket.connected && window.socket.emit);

  if (dualEmitLegacyEnabled && canUseServerless && canUseLegacy) {
    const serverlessOk = Boolean(sendViaServerless(eventName, payload));
    let legacyOk = false;
    try {
      window.socket.emit(eventName, payload);
      legacyOk = true;
    } catch (_) {
      legacyOk = false;
    }
    const success = serverlessOk || legacyOk;
    recordDivergence(legacyOk, serverlessOk);
    console.log("[Phase1C][Portal][emitRealtimeEvent] dual emit", {
      eventName,
      channels: ["legacy", "serverless"],
      success,
      legacy: legacyOk,
      serverless: serverlessOk,
      payload,
    });
    return success;
  }

  if (canUseServerless) {
    const ok = sendViaServerless(eventName, payload);
    recordDivergence(false, Boolean(ok));
    console.log("[Phase1C][Portal][emitRealtimeEvent] serverless send", {
      eventName,
      channels: ["serverless"],
      success: Boolean(ok),
      payload,
    });
    return ok;
  }

  // Compatibility path: if a page has access to presenceWs but the helper
  // function is not installed, send the same envelope directly.
  if (
    window &&
    window.presenceWs &&
    typeof window.presenceWs.send === "function" &&
    window.presenceWs.readyState === 1
  ) {
    const traceId =
      payload && typeof payload === "object" && (payload.traceId || payload.consultTraceId)
        ? payload.traceId || payload.consultTraceId
        : `${eventName}-${Date.now()}`;
    window.presenceWs.send(
      JSON.stringify({
        action: eventName,
        timestamp: Date.now(),
        payload:
          payload && typeof payload === "object"
            ? { ...payload, traceId }
            : { value: payload, traceId },
      })
    );
    console.log("[Phase1C][Portal][emitRealtimeEvent] serverless send via presenceWs", {
      eventName,
      traceId,
      payload,
    });
    return true;
  }

  if (window && window.socket && window.socket.emit) {
    window.socket.emit(eventName, payload);
    recordDivergence(true, false);
    console.log("[Phase1C][Portal][emitRealtimeEvent] legacy socket send", {
      eventName,
      channels: ["legacy"],
      success: true,
      payload,
    });
    return true;
  }

  console.warn("[Phase1C][Portal][emitRealtimeEvent] no active socket", {
    eventName,
  });
  return false;
};




// WEBPACK FOOTER //
// ./src/utils/realtimeEventEmitter.js